module.exports = __webpack_public_path__ + "static/img/service-2.b963efe0.png";